module.exports = __webpack_public_path__ + "static/media/arrow-down.e0db79f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = 1201
// module chunks = 0